import serviceClient from '../core/service-client/service-client';

const asyncJobStatuses = {
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
  FAILED: 'failed',
};

const pollAsyncJob = async ({ jobId, interval, abortSignal, onPoll }) => {
  const client = serviceClient.get();
  const { data } = await client.getAsyncJob(jobId);
  let jobData = data;
  const { status } = jobData;

  if (onPoll) {
    onPoll(jobData);
  }

  if (abortSignal?.aborted) {
    throw new DOMException('Aborted by the user', 'AbortError');
  }

  switch (status) {
    case asyncJobStatuses.IN_PROGRESS: {
      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          try {
            jobData = await pollAsyncJob({ jobId, interval, abortSignal, onPoll });
            resolve(jobData);
          } catch (e) {
            reject(e);
          }
        }, interval);
      });
    }
    case asyncJobStatuses.FAILED: {
      throw jobData;
    }
    case asyncJobStatuses.COMPLETE:
    default: {
      return jobData;
    }
  }
};

export default pollAsyncJob;
